/**
 * The ConvertDocumentToPdfStatus has four status completed, processing, skipped, and failed.
 * But for now the skipped status is not used.
 * @see https://gitlab.com/mindtickle/dsr/dsr-core-api/-/blob/dev/app/models/content_processing_log.rb
 */
export enum ContentProcessingStatus {
  Completed = 'completed',
  Processing = 'processing',
  Failed = 'failed',
}

/**
 * @see https://gitlab.com/mindtickle/dsr/dsr-core-api/-/blob/dev/app/graphql/application/types/contents/content_processing_log_processor_enum_type.rb
 */
export enum ContentProcessors {
  ConvertapiDocumentToPdf = 'ConvertapiDocumentToPdf',
  LambdaDocumentToPdf = 'LambdaDocumentToPdf',
}
